module.exports = __webpack_public_path__ + "static/img/continue.59082097.png";